import { loadScript } from '../shared/actions/scripts.action'

export const loadPlaid = () => dispatch => {
  loadScript(
    'Plaid',
    'https://cdn.plaid.com/link/v2/stable/link-initialize.js'
  )(dispatch)
}
